import { createContext, type ReactNode, useContext } from 'react';

const TableLoadingContext = createContext<boolean>(false);

export function TableLoadingProvider({ children, isLoading }: { children: ReactNode; isLoading: boolean }) {
  return <TableLoadingContext.Provider value={isLoading}>{children}</TableLoadingContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTableLoading(): boolean {
  return useContext(TableLoadingContext);
}
